<template>
  <v-container id="bills" fluid tag="section">
    <div class="text-right">
      <v-btn color="blue" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/bill/create'">
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title>{{ $i18n.t("Add New") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Bill From Date')"
                v-model="filter.billFromDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Bill To Date')"
                v-model="filter.billToDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Due From Date')"
                v-model="filter.dueFromDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Due To Date')"
                v-model="filter.dueToDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-account-select
                :label="$i18n.t('Account')"
                v-model="filter.account"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-vendor-select withSelf clearable v-model="filter.vendor_id" />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <v-text-field
                :label="$i18n.t('Bill No.')"
                v-model="filter.invoiceNo"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <v-text-field
                :label="$i18n.t('Order No.')"
                v-model="filter.orderNo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-card-text-outline"
      :title="$i18n.t('Bills')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th class="text-left">
                {{ $i18n.t("Bill No.") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Title") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Order No.") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Bill Date") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Due Date") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Vendor") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Amount") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Status") }}
              </th>
              <th class="text-right">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <bill-row
            v-for="item in grid.rows"
            :key="item._id"
            :value="item"
            @reload="reload"
            :refresh="refresh"
          />
        </template>
      </v-simple-table>

      <!-- <v-virtual-scroll
        :bench="5"
        :items="grid.rows"
        :height="gridHeight"
        :item-height="itemHeight"
      >
        <template v-slot="{ item }">
          <bill-row :value="item" @reload="reload" :refresh="refresh" />
          <v-divider></v-divider>
        </template>
      </v-virtual-scroll> -->

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import BillRow from "@/views/bill/BillRow.vue";

@Component({
  name: "Bills",
  components: { BillRow },
})
export default class Bills extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/bill/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;

  filter = {
    billFromDate: null,
    billToDate: null,
    dueFromDate: null,
    dueToDate: null,
    account: null,
    vendor_id: null,
    invoiceNo: null,
    orderNo: null,
  };

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  async mounted() {
    this.showPage(1);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      if (grid.rows && grid.rows.length > 0) {
        // for (let i = 0; i < grid.rows.length; i++) {
        //   grid.rows[i].selected = false;
        //   grid.rows[i]._showAssign = false;
        // }
      }
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {
      billFromDate: "",
      billToDate: "",
      dueFromDate: "",
      dueToDate: "",
      account: null,
      vendor_id: null,
      invoiceNo: null,
      orderNo: null,
    };

    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search() {
    this.filterUrl = "";
    if (this.filter.billFromDate)
      this.filterUrl += "&startDate=" + this.filter.billFromDate;
    if (this.filter.billToDate)
      this.filterUrl += "&endDate=" + this.filter.billToDate;
    if (this.filter.dueFromDate)
      this.filterUrl += "&dueStartDate=" + this.filter.dueFromDate;
    if (this.filter.dueToDate)
      this.filterUrl += "&dueEndDate=" + this.filter.dueToDate;
    if (this.filter.account)
      this.filterUrl += "&items.accountCode=" + this.filter.account;
    if (this.filter.vendor_id)
      this.filterUrl += "&vendor_id=" + this.filter.vendor_id;
    if (this.filter.invoiceNo)
      this.filterUrl += "&bill=" + this.filter.invoiceNo;
    if (this.filter.orderNo) this.filterUrl += "&order=" + this.filter.orderNo;
    common.setLoading(true);
    await this.showPage(1);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
